var _g, _g2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCheckMark = function SvgCheckMark(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "checked_5_",
    "data-name": "checked (5)",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5939",
    "data-name": "Group 5939",
    transform: "translate(4.749 2.513)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5938",
    "data-name": "Group 5938"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77986",
    "data-name": "Path 77986",
    d: "M136.247,64.549a.754.754,0,0,0-1.066,0l-9.043,9.019-3.263-3.543a.754.754,0,0,0-1.109,1.021l3.794,4.12a.753.753,0,0,0,.538.243h.016a.755.755,0,0,0,.532-.22l9.6-9.573A.754.754,0,0,0,136.247,64.549Z",
    transform: "translate(-121.568 -64.327)",
    fill: "#11616a"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_5941",
    "data-name": "Group 5941"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5940",
    "data-name": "Group 5940"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77987",
    "data-name": "Path 77987",
    d: "M19.246,9.246a.754.754,0,0,0-.754.754A8.492,8.492,0,1,1,10,1.508.754.754,0,1,0,10,0,10,10,0,1,0,20,10,.754.754,0,0,0,19.246,9.246Z",
    fill: "#11616a"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCheckMark, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/check-mark.c6252345.svg";
export { ForwardRef as ReactComponent };